<template>
  <div :class="mclass !== '' ? mclass : 'section hf_lightlemonbg'">
    <div class="container">
      <text-image v-if="type == 'textimage'"
        :rclass = rclass
        :cmlass = cmlass
        :lmclass = lmclass
        :rmclass = rmclass
        :show_goal_count = show_goal_count
        :show_cta = show_cta
        :heading = heading
        :hmclass = hmclass
        :heading_class = heading_class
        :image = image
        :body = body
        :body_class = body_class
        :cta = cta
        :lazy= lazy>
      </text-image>

      <image-text v-if="type == 'imagetext'"
        :rclass = rclass
        :cmlass = cmlass
        :lmclass = lmclass
        :rmclass = rmclass
        :show_goal_count = show_goal_count
        :show_cta = show_cta
        :heading = heading
        :hmclass = hmclass
        :heading_class = heading_class
        :image = image
        :body = body
        :body_class = body_class
        :cta = cta
        :lazy= lazy>
      </image-text>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      imgExtension : ''
    }
  },
  props: {
    //classes
    //===========================================
    section_display_as: { type: String, default: '' },
    //classes
    //===========================================
    mclass: { type: String, default: '' }, // main class
    // Inner component property
    rclass: { type: String, default: '' }, // row class
    cmlass: { type: String, default: '' }, // row class
    lmclass: { type: String, default: '' }, // left main class
    rmclass: { type: String, default: '' }, // right main class
    show_goal_count: { type: Boolean, default: false },

    heading: { type:String, default:'' },
    hmclass: { type: String, default: '' }, // heading main class
    heading_class: { type:String, default:'' },
    type: { type: String, default: 'imagetext' }, //imagetext, textimage, texttext, imageimage
    image: { type: Object, required:true },
    body: { type: String, default:''},
    body_class: { type: String, default:''},
    cta: { type: Object, default:{} },
    show_cta : { type:Boolean, default:false },
    lazy:{ type:Boolean, default:false },
  },
  mounted(){
    // console.log(this.show_goal_count);
    if( this.image ){
      if( this.image.hasOwnProperty('src') ){
        var imageObject = this.image.src.split(".");
        this.imgExtension = imageObject[1];
        // console.log(this.imgExtension);
      }
    }
    
  }
}

</script>
